export default (editor, opts = {}) => {
    
};
